<template>
    <div class="container p-4" style="background:">
        
        <h2 style="text-align:center ;font-size:32px;font-weight:600;color:#000;padding-bottom:0" class="">{{$t("Product.lisens")}}</h2>
        <div class="Titleline"></div>
        <div  style="padding:10px 0">
            <div class="proofBox">
                <el-carousel :interval="4000" type="card" height="500px" class="carousel-li">
                    <el-carousel-item v-for="(item,subindex) in lisenImg" :key="subindex">
                    <div @click="jump(item.src,item.txt)" class="proof">
                        <b-img  fluid :src=item.src  class="recommendImg" ref="Imgs"></b-img>
                        <div class="p-3">
                            
                            <p class="productName" style="text-align:center;font-size:16px">{{item.txt}}</p>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        
    </div>
</template>

<script>

export default {
    data(){
        return{
        
            lisenImg:[
                {src: require('../../../../static/Updatedimg/0_1.jpg'),
                 txt:'高新技术企业'
                },
                {src: require('../../../../static/Updatedimg/lisen-1.jpg'),
                 txt:'基于表面线性弹性理论的圆锯片公差智能检测系统'
                 },
                 {src: require('../../../../static/Updatedimg/lisen-2.jpg'),
                 txt:'一种高效圆锯片热处理装置'
                 },
                 {src: require('../../../../static/Updatedimg/lisen-3.jpg'),
                 txt:'一种圆锯片快速冷却装置'
                 },
                 {src: require('../../../../static/Updatedimg/lisen-4.jpg'),
                 txt:'一种涂镀设备用高效泵抽系统'
                 },
                 {src: require('../../../../static/Updatedimg/lisen-5.jpg'),
                 txt:'一种便于涂层附着的合金锯片'
                 },
                 {src: require('../../../../static/Updatedimg/lisen-6.jpg'),
                 txt:'一种锯齿可调节的圆锯片'
                 },
                 {src: require('../../../../static/Updatedimg/lisen-7.jpg'),
                 txt:'一种耐磨圆锯片'
                 },
                 {src: require('../../../../static/Updatedimg/lisen-8.jpg'),
                 txt:'一种消音组合式圆锯片'
                 },
                 {src: require('../../../../static/Updatedimg/3445874-1.jpg'),
                 txt:'一种提高圆锯片切削速度的多层复合涂层'
                 },
                 {src: require('../../../../static/Updatedimg/3445875-1.jpg'),
                 txt:'一种物理气相沉积法在圆锯片上制备的复合涂层'
                 },
                 {src: require('../../../../static/Updatedimg/3447944-1.jpg'),
                 txt:'一种圆锯片表面的复合纳米涂层'
                 },
                 
            ],
            AfterImg:[]
    }
    },
    methods:{
               
            jump(jpg,title){
                 this.$router.push({
                    name:'licensedetail',
                    params:{
                    jpg:jpg,
                    title:title
                }
                })
                
            },
            PrelisenImg(){
                    const result=[];
                    for(var i=0;i<this.lisenImg.length;i+=4){
                    result.push(this.lisenImg.slice(i,i+4));      
                    }
                    // console.log(result)
                    this.AfterImg=result;
            } 
            },
            created:function(){
                this.PrelisenImg()
            }
}
</script>



<style scoped>
@import url('../../../assets/css/anim.css');
   
    .lisBox{
        max-width: 294.5px !important;
        
        margin:2px;
        /* margin-left: 20px; */
        /* background: url('../../static/images/proitembg2.jpg'); */
        /* background-position: center */
        
    }
   
    .ProRow{
        padding-top: 10px
    }
    .Cardline{
        border: 2px solid #666;
        width:120px ;

        margin: 4px auto;
    }
    .proof{
        padding-top: 10%;
    }
    .productName{
        font-size: 18px !important;
        font-weight: 600;
    }
    .el-carousel__item:nth-child(2n) {
    background-color: #2c3e50 !important;
    color: antiquewhite
}
    .el-carousel__item--card{
        display: flex;
        align-items: center
    }
    @media (max-width: 768px) {
        .productName {
            font-size: 14px!important;
            font-weight: 600;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            /* -webkit-line-clamp: 1; */
            -webkit-line-clamp: 2;
            overflow: hidden;
        }
    }
    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 200px;
        margin: 0;
    }
    
    .el-carousel__item:nth-child(2n) {
        background-color: #C0C4CC;
    }
    
    .el-carousel__item:nth-child(2n+1) {
        background-color: #E4E7ED;
    }
    
    .el-carousel__container{
        height: 500px;
    }
    @media (max-width: 768px) {
        .proofBox .carousel-li{
        height: 260px !important;
    }
    }
</style>
